import { Link } from "react-router-dom";
import { MapPin, Star, Zap, ArrowUp, Truck } from "lucide-react";
import { imageUrl, srcSet } from "@/lib/api";
import { useFocus } from "@/lib/focus";
import { gbp } from "@/data/shop";
import { deliveryLabel } from "@/data/community";

export const AdBadges = ({ ad, size = "text-[11px]" }) => (
  <>
    {ad.featured && <span className={`inline-flex items-center gap-1 ${size} font-bold px-2 py-0.5 rounded-full bg-[#FFD23F] text-[#202A35]`} data-testid={`ad-featured-${ad.id}`}><Star size={11} /> Featured</span>}
    {ad.urgent && <span className={`inline-flex items-center gap-1 ${size} font-bold px-2 py-0.5 rounded-full bg-[#C0392B] text-white`} data-testid={`ad-urgent-${ad.id}`}><Zap size={11} /> Urgent</span>}
    {ad.bumped && <span className={`inline-flex items-center gap-1 ${size} font-bold px-2 py-0.5 rounded-full bg-[#DCEEFF] text-[#202A35]`} data-testid={`ad-bumped-${ad.id}`}><ArrowUp size={11} /> Bumped</span>}
  </>
);

export const AdCard = ({ ad }) => {
  const img = ad.images?.[0] ? imageUrl(ad.images[0]) : null;
  const focus = useFocus(ad.images?.[0]);
  return (
    <Link to={`/community/ad/${ad.id}`} className="group bg-white rounded-2xl border-2 border-[#202A35]/10 overflow-hidden flex flex-col hover:border-[#202A35] transition-colors" data-testid={`ad-card-${ad.id}`}>
      <div className="relative aspect-[4/3] bg-[#F5F6F7] overflow-hidden">
        {img && <img src={img} srcSet={srcSet(img)} sizes="(min-width: 1024px) 240px, 50vw" width="400" height="300" alt={ad.title} loading="lazy" style={focus} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}
        <div className="absolute top-2 left-2 flex flex-wrap gap-1"><AdBadges ad={ad} /></div>
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <p className="font-display text-lg font-bold" data-testid={`ad-price-${ad.id}`}>{gbp(ad.price)}</p>
        <h3 className="text-sm font-semibold line-clamp-2">{ad.title}</h3>
        <p className="mt-1 text-[11px] text-[#202A35]/60 flex items-center gap-1"><MapPin size={11} /> {ad.location} · {ad.condition}</p>
        {ad.delivery && <p className="mt-1 text-[11px] font-bold text-[#168A5B] flex items-center gap-1" data-testid={`ad-card-delivery-${ad.id}`}><Truck size={11} /> {deliveryLabel(ad.delivery)}</p>}
        <p className="mt-auto pt-2 text-[11px] text-[#202A35]/55" data-testid={`ad-seller-${ad.id}`}>Sold by {ad.seller_name} ({ad.seller_type === "business" ? "business" : "private seller"})</p>
      </div>
    </Link>
  );
};
